const { __ } = wp.i18n;
const {
	InspectorControls,
	PanelColorSettings,
	// withColors,
} = wp.blockEditor;
const {
	Button,
	PanelBody,
	RangeControl,
	ToggleControl,
	SelectControl,
	ButtonGroup,
	ColorIndicator,
	BaseControl,
	Disabled,
	Icon,
} = wp.components;
const {
	ColorPalette,
} = wp.blockEditor;
const {
	useState,
} = wp.element;
const {
	subscribe,
	select,
} = wp.data;

import Select from 'react-select';
import * as FeatherIcon from 'react-feather';
import { filter, min, find, findIndex } from 'lodash';

import {
	PARALLAX_DIRECTIONS,
	ARROW_POSITIONS,
	DOT_POSITIONS,
	LIGHTGALLERY_TRANSITIONS,
	LIGHTGALLERY_TITLE,
	LIGHTGALLERY_DESCRIPTION
} from '../attributes';
import UnitButton from '../../../components/unit-button';
import { ResponsiveTabs } from '../../../components/reusable/responsive-tabs/ResponsiveTabs';
import SliderHeightControls from '../slider-height-controls';
import icons from '../../icons';
import { updateDotsAndSetAttributes } from '../../utils';

const DIVIDER_OPTIONS = eedeeGutenslider.gutensliderDividers;

export default ( props ) => {
	const { attributes, setAttributes, deviceType } = props;
	const {
		gsBlockId,
		contentMode,
		animation,
		duration,
		dots,
		dotsMd,
		dotsSm,
		dotSize,
		dotSizeMd,
		dotSizeSm,
		dotColor,
		dotPosition,
		dotYOffset,
		dotYOffsetMd,
		dotYOffsetSm,
		arrows,
		arrowsMd,
		arrowsSm,
		arrowSize,
		arrowSizeMd,
		arrowSizeSm,
		arrowColor,
		arrowBgColor,
		arrowHoverColor,
		arrowBgHoverColor,
		arrowStyle,
		arrowPosition,
		arrowXOffset,
		arrowXOffsetMd,
		arrowXOffsetSm,
		arrowYOffset,
		arrowYOffsetMd,
		arrowYOffsetSm,
		arrowXSpacing,
		arrowMixBlendMode,
		slidesToShow,
		slidesToShowMd,
		slidesToShowSm,
		slidesToScroll,
		slidesToScrollMd,
		slidesToScrollSm,
		sliderHeight,
		sliderHeightSm,
		sliderHeightMd,
		paddingX,
		paddingXMd,
		paddingXSm,
		paddingY,
		paddingYMd,
		paddingYSm,
		marginX,
		marginXMd,
		marginXSm,
		marginY,
		marginYMd,
		marginYSm,
		isFullScreen,
		fadeSpeed,
		hasParallax,
		pauseOnFocus,
		pauseOnHover,
		pauseOnDotsHover,
		parallaxDirection,
		parallaxAmount,
		autoplay,
		contentOpacity,
		loop,
		adaptiveHeight,
		adaptiveHeightMd,
		adaptiveHeightSm,
		zoom,
		spaceBetween,
		spaceBetweenMd,
		spaceBetweenSm,
		centeredSlides,
		dotType,
		isVertical,
		dividers,
		hasLg,
		lgTransition,
		lgBgColor,
		lgFontColor,
		lgTitle,
		lgCaption,
		lgZoomIcon,
		hasLgCounter,
		lgThumbnails,
		keyboardNavigation
	} = attributes;

	const innerSlides = filter( props.innerBlocks, { name: 'eedee/block-gutenslide' } );

	const dividerStyles = {
		container: ( provided ) => {
			return { ...provided, marginBottom: 14, marginTop: 4 };
		},
		valueContainer: ( provided ) => {
			return { ...provided, height: 58 };
		},
		option: ( provided, state ) => {
			const height = state.data.value === 'none' ? null : '50px';

			return { ...provided, height, width: '100%' };
		},
		singleValue: ( provided, state ) => {
			const height = state.data.value === 'none' ? null : '50px';

			return { ...provided, height, width: '100%' };
		},
	};

const dividerControls = (
		<>
			<BaseControl.VisualLabel>{ __( 'Top Divider', 'gutenslider' ) }</BaseControl.VisualLabel>
				<Select
					className="eedee-divider-select"
					defaultValue={ DIVIDER_OPTIONS[ 0 ] }
					label={ __( 'Select a top divider', 'gutenslider' ) }
					options={ Object.values( DIVIDER_OPTIONS ) }
					value={ DIVIDER_OPTIONS[ dividers.top.value ] }
					styles={ dividerStyles }
					formatOptionLabel={ ( data ) => {
						if ( data.svg ) {
							if ( dividers.top.inverted && data['svg-inverted']) {
								return (
									<span className="gutenslider-divider-top" dangerouslySetInnerHTML={ { __html: data['svg-inverted'] } } />
								);
							}
							return (
								<span className="gutenslider-divider-top" dangerouslySetInnerHTML={ { __html: data.svg } } />
							);
						}
						return (
							<span>{ data.label }</span>
						);
					} }
					onChange={ ( { value } ) => setAttributes( { dividers: { ...dividers, top: { ...dividers.top, value } } } ) }
					isSearchable={ false }
				/>
				{ dividers.top.value !== 'none' && <>
					<ColorPalette
						label={ __( 'Background Color', 'gutenslider' ) }
						value={ dividers.top.color }
						onChange={ ( value ) => setAttributes( { dividers: { ...dividers, top: { ...dividers.top, color: value } } } ) }
						disableCustomColors={ false }
						disableAlpha={ false }
						clearable={ false }
					/>
					<RangeControl
						label={ __( 'Top Divider Height', 'gutenslider' ) }
						value={ dividers.top.height }
						onChange={ ( value ) => setAttributes( { dividers: { ...dividers, top: { ...dividers.top, height: value } } } ) }
						min={ 0 }
						max={ 400 }
						step={ 1 }
					/>
					{ DIVIDER_OPTIONS[ dividers.top.value ]['svg-inverted'] && <ToggleControl
						label={ __( 'Invert', 'gutenslider' ) }
						checked={ dividers.top.inverted }
						onChange={ ( inverted ) => setAttributes( { dividers: { ...dividers, top: { ...dividers.top, inverted } } } ) }
					/> }
					<ToggleControl
						label={ __( 'Flip Vertical', 'gutenslider' ) }
						checked={ dividers.top.flipY }
						onChange={ ( flipY ) => setAttributes( { dividers: { ...dividers, top: { ...dividers.top, flipY } } } ) }
					/>
				</> }
				<BaseControl.VisualLabel>{ __( 'Bottom Divider', 'gutenslider' ) }</BaseControl.VisualLabel>
				<Select
					className="eedee-divider-select"
					defaultValue={ DIVIDER_OPTIONS[ 0 ] }
					label={ __( 'Select a bottom divider', 'gutenslider' ) }
					options={ Object.values( DIVIDER_OPTIONS ) }
					value={ DIVIDER_OPTIONS[ dividers.bottom.value ] }
					styles={ dividerStyles }
					formatOptionLabel={ ( data ) => {
						if ( data.svg ) {
							if ( dividers.bottom.inverted && data['svg-inverted']) {
								return (
									<span className="gutenslider-divider-bottom" dangerouslySetInnerHTML={ { __html: data['svg-inverted'] } } />
								);
							}
							return (
								<span className="gutenslider-divider-bottom" dangerouslySetInnerHTML={ { __html: data.svg } } />
							);
						}
						return (
							<span>{ data.label }</span>
						);
					} }
					onChange={ ( { value } ) => setAttributes( { dividers: { ...dividers, bottom: { ...dividers.bottom, value } } } ) }
					isSearchable={ false }
				/>
				{ dividers.bottom.value !== 'none' && <>
					<ColorPalette
						label={ __( 'Background Color', 'gutenslider' ) }
						value={ dividers.bottom.color }
						onChange={ ( value ) => setAttributes( { dividers: { ...dividers, bottom: { ...dividers.bottom, color: value } } } ) }
						disableCustomColors={ false }
						disableAlpha={ false }
						clearable={ false }
					/>
					<RangeControl
						label={ __( 'Bottom Divider Height', 'gutenslider' ) }
						value={ dividers.bottom.height }
						onChange={ ( value ) => setAttributes( { dividers: { ...dividers, bottom: { ...dividers.bottom, height: value } } } ) }
						min={ 0 }
						max={ 400 }
						step={ 1 }
					/>
					{ DIVIDER_OPTIONS[ dividers.bottom.value ]['svg-inverted'] && <ToggleControl
						label={ __( 'Invert', 'gutenslider' ) }
						checked={ dividers.bottom.inverted }
						onChange={ ( inverted ) => setAttributes( { dividers: { ...dividers, bottom: { ...dividers.bottom, inverted } } } ) }
					/> }
					<ToggleControl
						label={ __( 'Flip Vertical', 'gutenslider' ) }
						checked={ dividers.bottom.flipY }
						onChange={ ( flipY ) => setAttributes( { dividers: { ...dividers, bottom: { ...dividers.bottom, flipY } } } ) }
					/>
				</> }
			</> );

	const responsiveSliderHeightBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				sliderHeightResponsive: sliderHeight,
				adaptiveHeightResponsive: adaptiveHeight,
				slidesToShowResponsive: slidesToShow,
				isFullScreen: isFullScreen,
				label: ( <span> { __( 'Min Slider Height', 'gutenslider' ) }</span> ),
				onChangeSliderHeight: ( val ) => setAttributes( { sliderHeight: val } ),
				onChangeAdaptiveHeight: ( val ) => setAttributes( { adaptiveHeight: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				sliderHeightResponsive: sliderHeightMd,
				adaptiveHeightResponsive: adaptiveHeightMd,
				slidesToShowResponsive: slidesToShowMd,
				isFullScreen: isFullScreen,
				label: ( <span> { __( 'Min Slider Height', 'gutenslider' ) } </span> ),
				onChangeSliderHeight: ( val ) => setAttributes( { sliderHeightMd: val } ),
				onChangeAdaptiveHeight: ( val ) => setAttributes( { adaptiveHeightMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				sliderHeightResponsive: sliderHeightSm,
				adaptiveHeightResponsive: adaptiveHeightSm,
				slidesToShowResponsive: slidesToShowSm,
				isFullScreen: isFullScreen,
				label: ( <span> { __( 'Min Slider Height', 'gutenslider' ) }</span> ),
				onChangeSliderHeight: ( val ) => setAttributes( { sliderHeightSm: val } ),
				onChangeAdaptiveHeight: ( val ) => setAttributes( { adaptiveHeightSm: val } ),
			},
		},
	];

	const responsivePaddingXBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				value: paddingX,
				label: ( <span> { __( 'Left + Right', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { paddingX: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				value: paddingXMd,
				label: ( <span> { __( 'Left + Right', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { paddingXMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				value: paddingXSm,
				label: ( <span> { __( 'Left + Right', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { paddingXSm: val } ),
			},
		},
	];

	const responsivePaddingYBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				value: paddingY,
				label: ( <span> { __( 'Top + Bottom', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { paddingY: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				value: paddingYMd,
				label: ( <span> { __( 'Top + Bottom', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { paddingYMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				value: paddingYSm,
				label: ( <span> { __( 'Top + Bottom', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { paddingYSm: val } ),
			},
		},
	];

	const responsiveMarginXBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				value: marginX,
				label: ( <span> { __( 'Left + Right', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { marginX: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				value: marginXMd,
				label: ( <span> { __( 'Left + Right', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { marginXMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				value: marginXSm,
				label: ( <span> { __( 'Left + Right', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { marginXSm: val } ),
			},
		},
	];

	const responsiveMarginYBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				value: marginY,
				label: ( <span> { __( 'Top + Bottom', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { marginY: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				value: marginYMd,
				label: ( <span> { __( 'Top + Bottom', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { marginYMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				value: marginYSm,
				label: ( <span> { __( 'Top + Bottom', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { marginYSm: val } ),
			},
		},
	];

	const spaceBetweenBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				label: ( <span> { __( 'Space Between', 'gutenslider' ) }</span> ),
				value: spaceBetween,
				onChange: ( val ) => setAttributes( { spaceBetween: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				label: ( <span> { __( 'Space Between', 'gutenslider' ) } </span> ),
				value: spaceBetweenMd,
				onChange: ( val ) => setAttributes( { spaceBetweenMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				label: ( <span> { __( 'Space Between', 'gutenslider' ) }</span> ),
				value: spaceBetweenSm,
				onChange: ( val ) => setAttributes( { spaceBetweenSm: val } ),
			},
		},
	];

	const slidesToShowBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				label: ( <span> { __( 'Slides to Show', 'gutenslider' ) }</span> ),
				value: slidesToShow,
				onChange: ( val ) => setAttributes( {
					slidesToShow: val < 1 && val > 0 ? 0 : val,
					adaptiveHeight: val === 0 ? false : adaptiveHeight,
				} ),
				help: slidesToShow === 0 ? __( 'Auto Slides per view will set the slider to the height you set in the "Min Slider Height" setting, and disable automatic height recognition. So check yourself that the content does not overflow the slides.', 'gutenslider' ) : null,
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				label: ( <span> { __( 'Slides to Show', 'gutenslider' ) } </span> ),
				value: slidesToShowMd,
				onChange: ( val ) => setAttributes( {
					slidesToShowMd: val < 1 && val > 0 ? 0 : val,
					adaptiveHeightMd: val === 0 ? false : adaptiveHeightMd,
				} ),
				help: slidesToShowMd === 0 ? __( 'Auto Slides per view will set the slider to the height you set in the "Min Slider Height" setting, and disable automatic height recognition. So check yourself that the content does not overflow the slides.', 'gutenslider' ) : null,
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				label: ( <span> { __( 'Slides to Show', 'gutenslider' ) }</span> ),
				value: slidesToShowSm,
				onChange: ( val ) => setAttributes( {
					slidesToShowSm: val < 1 && val > 0 ? 0 : val,
					adaptiveHeightSm: val === 0 ? false : adaptiveHeightSm,
				} ),
				help: slidesToShowSm === 0 ? __( 'Auto Slides per view will set the slider to the height you set in the "Min Slider Height" setting, and disable automatic height recognition. So check yourself that the content does not overflow the slides.', 'gutenslider' ) : null,
			},
		},
	];

	const slidesToScrollBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				label: ( <span> { __( 'Slides to Scroll', 'gutenslider' ) }</span> ),
				value: slidesToScroll,
				onChange: ( val ) => setAttributes( { slidesToScroll: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				label: ( <span> { __( 'Slides to Scroll', 'gutenslider' ) } </span> ),
				value: slidesToScrollMd,
				onChange: ( val ) => setAttributes( { slidesToScrollMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				label: ( <span> { __( 'Slides to Scroll', 'gutenslider' ) }</span> ),
				value: slidesToScrollSm,
				onChange: ( val ) => setAttributes( { slidesToScrollSm: val } ),
			},
		},
	];

	const dotsBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				checked: dots,
				label: ( <span> { __( 'Show Progress', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { dots: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				checked: dotsMd,
				label: ( <span> { __( 'Show Progress', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { dotsMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				checked: dotsSm,
				label: ( <span> { __( 'Show Progress', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { dotsSm: val } ),
			},
		},
	];

	const dotSizeBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				value: dotSize,
				label: ( <span> { __( 'Progress Size', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { dotSize: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				value: dotSizeMd,
				label: ( <span> { __( 'Progress Size', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { dotSizeMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				value: dotSizeSm,
				label: ( <span> { __( 'Progress Size', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { dotSizeSm: val } ),
			},
		},
	];

	const arrowBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				checked: arrows,
				label: ( <span> { __( 'Show Arrows', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { arrows: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				checked: arrowsMd,
				label: ( <span> { __( 'Show Arrows', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { arrowsMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				checked: arrowsSm,
				label: ( <span> { __( 'Show Arrows', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { arrowsSm: val } ),
			},
		},
	];

	const arrowSizeBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				value: arrowSize,
				label: ( <span> { __( 'Arrow Size', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { arrowSize: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				value: arrowSizeMd,
				label: ( <span> { __( 'Arrow Size', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { arrowSizeMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				value: arrowSizeSm,
				label: ( <span> { __( 'Arrow Size', 'gutenslider' ) }</span> ),
				onChange: ( val ) => setAttributes( { arrowSizeSm: val } ),
			},
		},
	];

	const arrowXOffsetBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				value: arrowXOffset,
				label: ( <span> { __( 'Arrow X Offset', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { arrowXOffset: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				value: arrowXOffsetMd,
				label: ( <span> { __( 'Arrow X Offset', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { arrowXOffsetMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				value: arrowXOffsetSm,
				label: ( <span> { __( 'Arrow X Offset', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { arrowXOffsetSm: val } ),
			},
		},
	];

	const arrowYOffsetBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				value: arrowYOffset,
				label: ( <span> { __( 'Arrow Y Offset', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { arrowYOffset: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				value: arrowYOffsetMd,
				label: ( <span> { __( 'Arrow Y Offset', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { arrowYOffsetMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				value: arrowYOffsetSm,
				label: ( <span> { __( 'Arrow Y Offset', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { arrowYOffsetSm: val } ),
			},
		},
	];

	const dotYOffsetBreakpoints = [
		{
			name: 'Desktop',
			componentProps: {
				value: dotYOffset,
				label: ( <span> { __( 'Progress Offset', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { dotYOffset: val } ),
			},
		},
		{
			name: 'Tablet',
			componentProps: {
				value: dotYOffsetMd,
				label: ( <span> { __( 'Progress Offset', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { dotYOffsetMd: val } ),
			},
		},
		{
			name: 'Mobile',
			componentProps: {
				value: dotYOffsetSm,
				label: ( <span> { __( 'Progress Offset', 'gutenslider' ) } </span> ),
				onChange: ( val ) => setAttributes( { dotYOffsetSm: val } ),
			},
		},
	];

	const arrowPanelTitle = (
		<span className="editor-panel-color-settings__panel-title block-editor-panel-color-settings__panel-title">
			{ __( 'Arrows', 'gutenslider' ) }
			<ColorIndicator
				aria-label="(border color: #000)"
				colorValue={ arrowColor }
			/>
		</span>
	);

	const dotPanelTitle = (
		<span className="editor-panel-color-settings__panel-title block-editor-panel-color-settings__panel-title">
			{ __( 'Progress', 'gutenslider' ) }
			<ColorIndicator
				aria-label="(border color: #000)"
				colorValue={ dotColor } />
		</span>
	);

	return (
		<InspectorControls>
			<PanelBody
				title={ __( 'General', 'gutenslider' ) }
				className="gutenslider-controls gutenslider-controls-general eedee-icon-panel"
				icon={ <FeatherIcon.Settings color={ '#000' } size={ 18 } /> }
			>
				<BaseControl help={ __( 'Choose the transition between slides', 'gutenslider' ) }>
					<BaseControl.VisualLabel>{ __( 'Animation', 'gutenslider' ) }</BaseControl.VisualLabel>
					<ButtonGroup aria-label={ __( 'Fade Mode', 'gutenslider' ) } className="gutenslider-toggle-fade-mode">
						<Button
							isSecondary={ animation !== 'slide' }
							isPrimary={ animation === 'slide' }
							aria-pressed={ animation === 'slide' }
							onClick={ () => {
								setAttributes( { animation: 'slide' } );
							} }
						>
							{ __( 'slide', 'gutenslider' ) }
						</Button>
						<Button
							isSecondary={ animation !== 'fade' }
							isPrimary={ animation === 'fade' }
							aria-pressed={ animation === 'fade' }
							onClick={ () => {
								setAttributes( { animation: 'fade' } );
							} }
						>
							{ __( 'fade', 'gutenslider' ) }
						</Button>
						<Button
							isSecondary={ animation !== 'flip' }
							isPrimary={ animation === 'flip' }
							aria-pressed={ animation === 'flip' }
							onClick={ () => {
								setAttributes( { animation: 'flip' } );
							} }
						>
						{ __( 'flip', 'gutenslider' ) }
						</Button>
						</ButtonGroup>
						<ButtonGroup aria-label={ __( 'Fade Mode', 'gutenslider' ) } className="gutenslider-toggle-fade-mode">
						<Button
							isSecondary={ animation !== 'coverflow' }
							isPrimary={ animation === 'coverflow' }
							aria-pressed={ animation === 'coverflow' }
							onClick={ () => {
								setAttributes( { animation: 'coverflow' } );
							} }
						>
						{ __( 'coverflow', 'gutenslider' ) }
						</Button>
						<Button
							isSecondary={ animation !== 'cube' }
							isPrimary={ animation === 'cube' }
							aria-pressed={ animation === 'cube' }
							onClick={ () => {
								setAttributes( { animation: 'cube' } );
							} }
						>
							{ __( 'cube', 'gutenslider' ) }
						</Button>
						<Button
							isSecondary={ animation !== 'cards' }
							isPrimary={ animation === 'cards' }
							aria-pressed={ animation === 'cards' }
							onClick={ () => {
								setAttributes( { animation: 'cards' } );
							} }
						>
							{ __( 'cards', 'gutenslider' ) }
						</Button>
					</ButtonGroup>
				</BaseControl>
				<BaseControl help={ __( 'Can each slide have its own content or are child blocks fixed on top of all slides?', 'gutenslider' ) }>
					<BaseControl.VisualLabel>{ __( 'Slide Mode', 'gutenslider' ) }</BaseControl.VisualLabel>
					<ButtonGroup aria-label={ __( 'Slide Mode', 'gutenslider' ) } className="gutenslider-toggle-content-mode">
						<Button
							isSecondary={ contentMode !== 'fixed' }
							isPrimary={ contentMode === 'fixed' }
							aria-pressed={ contentMode === 'fixed' }
							onClick={ () => {
								setAttributes( { contentMode: 'fixed' } );
							} }
						>
							{ __( 'fixed', 'gutenslider' ) }
						</Button>
						<Button
							isSecondary={ contentMode === 'fixed' }
							isPrimary={ contentMode === 'change' }
							aria-pressed={ contentMode === 'change' }
							onClick={ () => {
								setAttributes( { contentMode: 'change' } );
							} }
						>
							{ __( 'changing', 'gutenslider' ) }
						</Button>
					</ButtonGroup>
				</BaseControl>
				<ResponsiveTabs
					breakpoints={ responsiveSliderHeightBreakpoints }
					selected={ deviceType }
				>
					<SliderHeightControls
						animation={ animation }
						isVertical={ isVertical }
						onChangeAllAdaptiveHeight={ ( val ) => setAttributes( {
							adaptiveHeight: val,
							adaptiveHeightMd: val,
							adaptiveHeightSm: val,
						} ) }
						onChangeAllSliderHeight={ ( val ) => setAttributes( {
							sliderHeight: val,
							sliderHeightMd: val,
							sliderHeightSm: val,
						} ) }
					/>
				</ResponsiveTabs>
				{ ( animation === 'slide' || animation === 'coverflow' ) && <ResponsiveTabs
					breakpoints={ slidesToShowBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						slidesToShow: val,
						slidesToShowMd: val,
						slidesToShowSm: val,
					} ) }
				>
					<RangeControl
						min={ 0 }
						max={ min( [ innerSlides.length, 8 ] ) }
						step={ 0.1 }
						marks={ [
							{
								value: 0,
								label: __( 'auto', 'gutenslider' ),
							},
							{
								value: 1,
								label: '1',
							},
							{
								value: 2,
								label: '2',
							},
							{
								value: 3,
								label: '3',
							},
							{
								value: 4,
								label: '4',
							},
							{
								value: 5,
								label: '5',
							},
							{
								value: 6,
								label: '6',
							},
							{
								value: 7,
								label: '7',
							},
							{
								value: 8,
								label: '8',
							},
						].slice( 0, min( [ innerSlides.length, 8 ] ) + 1 ) }
					/>
				</ResponsiveTabs> }
				{ ( animation === 'slide' || animation === 'coverflow' ) && <ResponsiveTabs
					breakpoints={ slidesToScrollBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						slidesToScroll: val,
						slidesToScrollMd: val,
						slidesToScrollSm: val,
					} ) }
				>
					<RangeControl
						min={ 1 }
						max={ min( [ innerSlides.length, 8 ] ) }
						step={ 1 }
						marks={ [
							{
								value: 1,
								label: '1',
							},
							{
								value: 2,
								label: '2',
							},
							{
								value: 3,
								label: '3',
							},
							{
								value: 4,
								label: '4',
							},
							{
								value: 5,
								label: '5',
							},
							{
								value: 6,
								label: '6',
							},
							{
								value: 7,
								label: '7',
							},
							{
								value: 8,
								label: '8',
							},
						].slice( 0, min( [ innerSlides.length, 8 ] ) + 1 ) }
					/>
				</ResponsiveTabs> }
				{ ( animation === 'slide' || animation === 'coverflow' ) &&
					<ResponsiveTabs
						breakpoints={ spaceBetweenBreakpoints }
						selected={ deviceType }
						onChangeAll={ ( val ) => setAttributes( {
						spaceBetween: val,
						spaceBetweenMd: val,
						spaceBetweenSm: val,
						} ) }
					>
						<RangeControl
							min={ 0 }
							max={ 200 }
							step={ 1 }
							marks={ [
								{ value: 0, label: __( '0px', 'gutenslider' ) },
								{ value: 200, label: __( '200px', 'gutenslider' ) },
							] }
						/>
					</ResponsiveTabs>
				}
				<RangeControl
					label={ __( 'Animation Speed (sec)', 'gutenslider' ) }
					value={ fadeSpeed }
					onChange={ ( val ) => setAttributes( { fadeSpeed: val } ) }
					min={ 0 }
					max={ 10 }
					step={ 0.1 }
					marks={ [
						{ value: 0, label: __( '0', 'gutenslider' ) },
						{ value: 100, label: __( '10', 'gutenslider' ) },
					] }
				/>
				{/* <ToggleControl
					label={ __( 'Vertical Slider', 'gutenslider' ) }
					checked={ isVertical }
					onChange={ ( val ) => setAttributes( { isVertical: val } ) }
				/> */}
				<ToggleControl
					label={ __( 'Autoplay', 'gutenslider' ) }
					checked={ autoplay }
					onChange={ ( val ) => setAttributes( { autoplay: val } ) }
				/>
				<ToggleControl
					checked={ keyboardNavigation }
					label={ __( 'Keyboard Navigation', 'gutenslider' ) }
					onChange={ ( val ) => setAttributes( { keyboardNavigation: val } ) }
				/>
				<ResponsiveTabs
					breakpoints={ arrowBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						arrows: val,
						arrowsMd: val,
						arrowsSm: val,
					} ) }
				>
					<ToggleControl />
				</ResponsiveTabs>
				<ResponsiveTabs
					breakpoints={ dotsBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						dots: val,
						dotsMd: val,
						dotsSm: val,
					} ) }
				>
					<ToggleControl />
				</ResponsiveTabs>
				<ToggleControl
					label={ __( 'Loop', 'gutenslider' ) }
					checked={ loop }
					help={ loop ? __( 'Loop preview is disabled in the editor. See the frontend for the looped slider.') : null }
					onChange={ ( val ) => setAttributes( { loop: val } ) }
				/>
				{ ( animation === 'coverflow' || animation === 'slide' ) && slidesToShow !== 1 && <ToggleControl
					label={ __( 'Centered Slides', 'gutenslider' ) }
					checked={ centeredSlides }
					onChange={ ( val ) => setAttributes( { centeredSlides: val } ) }
				/> }
				{ false && <ToggleControl
					label={ __( 'Zoom', 'gutenslider' ) }
					checked={ zoom }
					onChange={ ( val ) => setAttributes( { zoom: val } ) }
				/> }
				<ToggleControl
					label={ __( 'Fullscreen Background Slider', 'gutenslider' ) }
					checked={ isFullScreen }
					help={ isFullScreen ? __( 'Full Screen Background Slider preview is not available in the editor, check the live site to see it in action.', 'gutenslider' ) : null }
					onChange={ ( val ) => setAttributes( { isFullScreen: val } ) }
				/>
			</PanelBody>
			{ autoplay && <PanelBody
				title={ __( 'Autoplay', 'gutenslider' ) }
				className="gutenslider-controls gutenslider-controls-autoplay eedee-icon-panel"
				initialOpen={ false }
				icon={
					<svg className="dashicon" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" focusable="false"><path fill="none" d="M0 0h24v24H0V0z"></path><path fill="#000" d="M13.05 9.79L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zm0 0L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zm0 0L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"></path></svg>
				}
			>
				<ToggleControl
					label={ __( 'Pause on Hover', 'gutenslider' ) }
					checked={ pauseOnHover }
					onChange={ ( val ) => setAttributes( { pauseOnHover: val } ) }
				/>
				<RangeControl
					label={ __( 'Slide Duration (sec)', 'gutenslider' ) }
					value={ duration }
					onChange={ ( val ) => setAttributes( { duration: val } ) }
					min={ 0.0 }
					max={ 30 }
					step={ 0.1 }
				/>
			</PanelBody> }
			{ ( arrows || arrowsMd || arrowsSm ) && <PanelBody
				title={ arrowPanelTitle }
				className="gutenslider-controls gutenslider-controls-arrows eedee-icon-panel"
				initialOpen={ false }
				icon={ <FeatherIcon.ArrowRightCircle color={ '#000' }  size={ 18 } /> }
			>
				<Select
					className="eedee-divider-select"
					defaultValue={ eedeeGutenslider.arrows[0] }
					label={ __( 'Select Arrow Style', 'gutenslider' ) }
					options={ eedeeGutenslider.arrows }
					value={ eedeeGutenslider.arrows[ findIndex( eedeeGutenslider.arrows, { value: arrowStyle } ) ] }
					styles={ dividerStyles }
					formatOptionLabel={ ( data ) => {
						if ( data.next && data.prev ) {
							return (
								<div className="gutenslider-arrow-style-select">
									<span className="gutenslider-arrow-style-prev" dangerouslySetInnerHTML={ { __html: data['prev'] } } />
									<span className="gutenslider-arrow-style-next" dangerouslySetInnerHTML={ { __html: data['next'] } } />
								</div>
							);
						}
						return (
							<span>{ data.label }</span>
						);
					} }
					onChange={ ( { value } ) => setAttributes( { arrowStyle: value } ) }
					isSearchable={ false }
				/>
				<SelectControl
					label={ __( 'Arrow Position', 'gutenslider' ) }
					value={ arrowPosition }
					options={ ARROW_POSITIONS }
					onChange={ ( val ) => setAttributes( { arrowPosition: val } ) }
				/>
				<ResponsiveTabs
					breakpoints={ arrowSizeBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						arrowSize: val,
						arrowSizeMd: val,
						arrowSizeSm: val,
					} ) }
				>
					<RangeControl
						min={ 15 }
						max={ 200 }
						step={ 1 }
					/>
				</ResponsiveTabs>
				{ arrowPosition !== 'arrow-follow-mouse' && <ResponsiveTabs
					breakpoints={ arrowXOffsetBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						arrowXOffset: val,
						arrowXOffsetMd: val,
						arrowXOffsetSm: val,
					} ) }
				>
					<RangeControl
						min={ -200 }
						max={ 200 }
						step={ 1 }
					/>
				</ResponsiveTabs> }
				{ arrowPosition !== 'arrow-follow-mouse' && <ResponsiveTabs
					breakpoints={ arrowYOffsetBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						arrowYOffset: val,
						arrowYOffsetMd: val,
						arrowYOffsetSm: val,
					} ) }
				>
					<RangeControl
						min={ -200 }
						max={ 200 }
						step={ 1 }
					/>
				</ResponsiveTabs> }
				{ arrowPosition !== 'arrow-position-sides'
					&& arrowPosition !== 'arrow-position-top-bottom'
					&& arrowPosition !== 'arrow-follow-mouse'
					&& <RangeControl
					label={ __( 'Arrow Horizontal Spacing', 'gutenslider' ) }
					value={ arrowXSpacing }
					onChange={ ( val ) => setAttributes( { arrowXSpacing: val } ) }
					min={ 0 }
					max={ 100 }
					step={ 1 }
				/> }
				<BaseControl>
					<BaseControl.VisualLabel>{ __( 'Arrow Color', 'gutenslider' ) }</BaseControl.VisualLabel>
					<ColorPalette
						value={ arrowColor }
						onChange={ ( color ) => {
							setAttributes( { arrowColor: color } );
						} }
						disableCustomColors={ false }
						clearable={ false }
						disableAlpha={ false }
					/>
				</BaseControl>
				<BaseControl>
					<BaseControl.VisualLabel>{ __( 'Arrow Background Color', 'gutenslider' ) }</BaseControl.VisualLabel>
					<ColorPalette
						value={ arrowBgColor }
						onChange={ ( color ) => setAttributes( { arrowBgColor: color } ) }
						disableCustomColors={ false }
						clearable={ true }
					/>
				</BaseControl>
				{ arrowPosition !== 'arrow-follow-mouse' && <BaseControl>
					<BaseControl.VisualLabel>{ __( 'Arrow Hover Color', 'gutenslider' ) }</BaseControl.VisualLabel>
					<ColorPalette
						value={ arrowHoverColor }
						onChange={ ( color ) => setAttributes( { arrowHoverColor: color } ) }
						disableCustomColors={ false }
						clearable={ false }
					/>
				</BaseControl> }
				{ arrowPosition !== 'arrow-follow-mouse' && <BaseControl>
					<BaseControl.VisualLabel>{ __( 'Arrow Hover Background Color', 'gutenslider' ) }</BaseControl.VisualLabel>
					<ColorPalette
						value={ arrowBgHoverColor }
						onChange={ ( color ) => setAttributes( { arrowBgHoverColor: color } ) }
						disableCustomColors={ false }
						clearable={ true }
					/>
				</BaseControl> }
				<SelectControl
					label={ __( 'Arrow Mix Blend Mode', 'gutenslider' ) }
					value={ arrowMixBlendMode }
					options={ [
						{ label: 'None', value: 'none' },
						{ label: 'Color Burn', value: 'color-burn' },
						{ label: 'Color Dodge', value: 'color-dodge' },
						{ label: 'Difference', value: 'difference' },
						{ label: 'Exclusion', value: 'exclusion' },
						{ label: 'Saturation', value: 'saturation' },
					] }
					onChange={ ( val ) => setAttributes( { arrowMixBlendMode: val } ) }
				/>
			</PanelBody> }
			{ ( dots || dotsMd || dotsSm ) && <PanelBody
				title={ dotPanelTitle }
				className="gutenslider-controls gutenslider-controls-dots eedee-icon-panel"
				initialOpen={ false }
				icon={ <Icon icon={ icons.progress } /> }
			>
				<BaseControl.VisualLabel>{ __( 'Progress Style', 'gutenslider' ) }</BaseControl.VisualLabel>
				<ButtonGroup aria-label={ __( 'Progress Style', 'gutenslider' ) } className="gutenslider-toggle-fade-mode">
					<Button
						isSecondary={ dotType !== 'bullets' }
						isPrimary={ dotType === 'bullets' }
						aria-pressed={ dotType === 'bullets' }
						onClick={ () => {
							const newAttributes = { dotType: 'bullets' };
							if ( typeof find( DOT_POSITIONS, { value: dotPosition } ) === 'undefined' ||
								find( DOT_POSITIONS, { value: dotPosition } ).showIn.indexOf( 'bullets' ) === -1 ) {
								newAttributes.dotPosition = 'dot-position-bottom';
							}
							updateDotsAndSetAttributes( gsBlockId, newAttributes, setAttributes );
						} }
					>
						{ __( 'bullets', 'gutenslider' ) }
					</Button>
					{ ! isVertical && <Button
						isSecondary={ dotType !== 'dynamic' }
						isPrimary={ dotType === 'dynamic' }
						aria-pressed={ dotType === 'dynamic' }
						onClick={ () => {
							const newAttributes = { dotType: 'dynamic' };
							if ( typeof find( DOT_POSITIONS, { value: dotPosition } ) === 'undefined' ||
								find( DOT_POSITIONS, { value: dotPosition } ).showIn.indexOf( 'dynamic' ) === -1 ) {
								newAttributes.dotPosition = 'dot-position-bottom';
							}
							updateDotsAndSetAttributes( gsBlockId, newAttributes, setAttributes );
						} }
					>
					{ __( 'dynamic', 'gutenslider' ) }
					</Button> }
					<Button
						isSecondary={ dotType !== 'fraction' }
						isPrimary={ dotType === 'fraction' }
						aria-pressed={ dotType === 'fraction' }
						onClick={ () => {
							const newAttributes = { dotType: 'fraction' };
							if ( typeof find( DOT_POSITIONS, { value: dotPosition } ) === 'undefined' ) {
								newAttributes.dotPosition = 'dot-position-bottom';
							}
							updateDotsAndSetAttributes( gsBlockId, newAttributes, setAttributes );
						} }
					>
						{ __( 'fraction', 'gutenslider' ) }
					</Button>
					<Button
						isSecondary={ dotType !== 'progressbar' }
						isPrimary={ dotType === 'progressbar' }
						aria-pressed={ dotType === 'progressbar' }
						onClick={ () => {
							const newAttributes = { dotType: 'progressbar' };
							if ( typeof find( DOT_POSITIONS, { value: dotPosition } ) === 'undefined' ||
								find( DOT_POSITIONS, { value: dotPosition } ).showIn.indexOf( 'progressbar' ) === -1 ) {
								newAttributes.dotPosition = 'dot-position-bottom';
							}
							updateDotsAndSetAttributes( gsBlockId, newAttributes, setAttributes );
						} }
					>
					{ __( 'bar', 'gutenslider' ) }
					</Button>
				</ButtonGroup>
				<SelectControl
					className={ 'mt-2' }
					label={ __( 'Progress Position', 'gutenslider' ) }
					value={ dotPosition }
					options={ filter( DOT_POSITIONS, ( el ) => {
						return el.showIn.indexOf( dotType ) !== -1;
					} ) }
					onChange={ ( val ) => setAttributes( { dotPosition: val } ) }
				/>
				<ResponsiveTabs
					breakpoints={ dotSizeBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						dotSize: val,
						dotSizeMd: val,
						dotSizeSm: val,
					} ) }
				>
					<RangeControl
						min={ 5 }
						max={ 60 }
						step={ 1 }
					/>
				</ResponsiveTabs>
				<ResponsiveTabs
					breakpoints={ dotYOffsetBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						dotYOffset: val,
						dotYOffsetMd: val,
						dotYOffsetSm: val,
					} ) }
				>
					<RangeControl
						min={ -200 }
						max={ 200 }
						step={ 1 }
					/>
				</ResponsiveTabs>
				<ColorPalette
					label={ __( 'Dot Color', 'gutenslider' ) }
					value={ dotColor }
					onChange={ ( color ) => setAttributes( { dotColor: color } ) }
					disableCustomColors={ false }
					clearable={ false }
				/>
			</PanelBody> }
			<PanelBody
				title={ __( 'Effects', 'gutenslider' ) }
				initialOpen={ false }
				className="gutenslider-controls gutenslider-controls-effects eedee-icon-panel"
				icon={ <FeatherIcon.Zap color={ '#000' } size={ 18 } /> }
			>
				<ToggleControl
					label={ __( 'Parallax', 'gutenslider' ) }
					checked={ hasParallax }
					onChange={ ( val ) => setAttributes( { hasParallax: val } ) }
					help={ hasParallax ? __( 'Parallax is only enabled in the frontend. Check out the live results there.', 'gutenslider' ) : '' }
				/>
				{ hasParallax && <SelectControl
					label={ __( 'Parallax Direction', 'eedee-gutenslider' ) }
					value={ parallaxDirection }
					options={ PARALLAX_DIRECTIONS }
					onChange={ ( val ) => setAttributes( { parallaxDirection: val } ) }
				/> }
				{ hasParallax && <RangeControl
					label={ __( 'Parallax Amount', 'gutenslider' ) }
					value={ parallaxAmount }
					onChange={ ( val ) => setAttributes( { parallaxAmount: val } ) }
					min={ 1.1 }
					max={ 2 }
					step={ 0.1 }
				/> }
			</PanelBody>
			<PanelBody
				title={ __( 'Dividers', 'gutenslider' ) }
				initialOpen={ false }
				className="gutenslider-controls gutenslider-controls-dividers eedee-icon-panel"
				icon={ icons.divider }
			>
				{ animation === 'flip' && <Disabled>
					<p>{ __( 'Dividers are disabled if animation is set to flip.', 'gutenslider' ) }</p>
						{ dividerControls }
				</Disabled> }
				{ animation === 'cube' && <Disabled>
					<p>{ __( 'Dividers are disabled if animation is set to cube.', 'gutenslider' ) }</p>
						{ dividerControls }
				</Disabled> }
				{ animation === 'cards' && <Disabled>
					<p>{ __( 'Dividers are disabled if animation is set to cube.', 'gutenslider' ) }</p>
						{ dividerControls }
				</Disabled> }
				{ animation !== 'flip' && animation !== 'cube' && animation !== 'cards' &&
					dividerControls
				}
			</PanelBody>
			<PanelBody
				title={ __( 'Spacing', 'gutenslider' ) }
				initialOpen={ false }
				className={ 'gutenslider-controls gutenslider-controls-spacing eedee-icon-panel' }
				icon={ <svg className="dashicon" width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true" focusable="false"><g fill="#000"><path d="M12,18 L12,16 L6,16 L6,18 L2,18 C0.9,18 0,17.1 0,16 L0,12 L2,12 L2,6 L0,6 L0,2 C0,0.9 0.9,0 2,0 L6,0 L6,2 L12,2 L12,0 L16,0 C17.1,0 18,0.9 18,2 L18,6 L16,6 L16,12 L18,12 L18,16 C18,17.1 17.1,18 16,18 L12,18 Z M16,16 L16,2 L2,2 L2,16 L16,16 Z" fillRule="nonzero"></path><path d="M4,6 C4.55228475,6 5,6.44771525 5,7 L5,11 C5,11.5522847 4.55228475,12 4,12 C3.44771525,12 3,11.5522847 3,11 L3,7 C3,6.44771525 3.44771525,6 4,6 Z M14,6 C14.5522847,6 15,6.44771525 15,7 L15,11 C15,11.5522847 14.5522847,12 14,12 C13.4477153,12 13,11.5522847 13,11 L13,7 C13,6.44771525 13.4477153,6 14,6 Z M12,4 C12,4.55228475 11.5522847,5 11,5 L7,5 C6.44771525,5 6,4.55228475 6,4 C6,3.44771525 6.44771525,3 7,3 L11,3 C11.5522847,3 12,3.44771525 12,4 Z M12,14 C12,14.5522847 11.5522847,15 11,15 L7,15 C6.44771525,15 6,14.5522847 6,14 C6,13.4477153 6.44771525,13 7,13 L11,13 C11.5522847,13 12,13.4477153 12,14 Z" opacity="0.5"></path></g></svg> }
			>
			<BaseControl.VisualLabel>{ __( 'Padding', 'gutenslider' ) }</BaseControl.VisualLabel>
				<ResponsiveTabs
					breakpoints={ responsivePaddingXBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						paddingX: val,
						paddingXMd: val,
						paddingXSm: val,
					} ) }
				>
					<UnitButton
						units={ [
							{ value: 'px', label: 'px', default: 0, min: 0, max: 100 },
							{ value: '%', label: '%', default: 10, min: 0, max: 40 },
						] }
						step={ 1 }
						transformUnits={ true }
					/>
				</ResponsiveTabs>
				<ResponsiveTabs
					breakpoints={ responsivePaddingYBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						paddingY: val,
						paddingYMd: val,
						paddingYSm: val,
					} ) }
				>
					<UnitButton
						units={ [
							{ value: 'px', label: 'px', default: 0, min: 0, max: 100 },
							{ value: '%', label: '%', default: 10, min: 0, max: 40 },
						] }
						step={ 1 }
						transformUnits={ true }
					/>
				</ResponsiveTabs>

				<BaseControl.VisualLabel>{ __( 'Margin', 'gutenslider' ) }</BaseControl.VisualLabel>
				<ResponsiveTabs
					breakpoints={ responsiveMarginXBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						marginX: val,
						marginXMd: val,
						marginXSm: val,
					} ) }
				>
					<UnitButton
						units={ [
							{ value: 'px', label: 'px', default: 0, min: 0, max: 100 },
							{ value: '%', label: '%', default: 10, min: 0, max: 40 },
						] }
						step={ 1 }
						transformUnits={ true }
					/>
				</ResponsiveTabs>
				<ResponsiveTabs
					breakpoints={ responsiveMarginYBreakpoints }
					selected={ deviceType }
					onChangeAll={ ( val ) => setAttributes( {
						marginY: val,
						marginYMd: val,
						marginYSm: val,
					} ) }
				>
					<UnitButton
						units={ [
							{ value: 'px', label: 'px', default: 0, min: 0, max: 100 },
							{ value: '%', label: '%', default: 10, min: 0, max: 40 },
						] }
						step={ 1 }
						transformUnits={ true }
					/>
				</ResponsiveTabs>
			</PanelBody>
			<PanelBody
				title={ __( 'Lightgallery', 'eedee-gutenslider' ) }
				initialOpen={ false }
				className="gutenslider-controls gutenslider-controls-lightgallery eedee-icon-panel"
				icon={ <FeatherIcon.ZoomIn size={ 18 } /> }
			>
				<ToggleControl
					label={ __( 'Enable Lightgallery on image slides', 'eedee-gutenslider' ) }
					checked={ hasLg }
					onChange={ ( val ) => setAttributes( { hasLg: val } ) }
					help={ __( 'This feature opens the background image of the slide in a lightgallery on click. It will not zoom the content. Lightgallery is only visible in frontend', 'eedee-gutenslider' ) }
				/>
				{ hasLg && <>
					<BaseControl>
						<BaseControl.VisualLabel>{ __( 'Lightgallery Background Color', 'eedee-gutenslider' ) }</BaseControl.VisualLabel>
						<ColorPalette
							value={ lgBgColor }
							onChange={ ( color ) => {
								setAttributes( { lgBgColor: color } );
							} }
							disableCustomColors={ false }
							clearable={ false }
							disableAlpha={ false }
						/>
					</BaseControl>
					<BaseControl>
						<BaseControl.VisualLabel>{ __( 'Lightgallery Font / Icon color', 'eedee-gutenslider' ) }</BaseControl.VisualLabel>
						<ColorPalette
							value={ lgFontColor }
							onChange={ ( color ) => {
								setAttributes( { lgFontColor: color } );
							} }
							disableCustomColors={ false }
							clearable={ false }
							disableAlpha={ false }
						/>
					</BaseControl>
					<ToggleControl
						label={ __( 'Thumbnails', 'eedee-gutenslider' ) }
						checked={ lgThumbnails }
						onChange={ ( val ) => setAttributes( { lgThumbnails: val } ) }
						help={ __( 'Show thumbnails below lightgallery slider', 'eedee-gutenslider' ) }
					/>
					<ToggleControl
						label={ __( 'Zoom Icon', 'eedee-gutenslider' ) }
						checked={ lgZoomIcon }
						onChange={ ( val ) => setAttributes( { lgZoomIcon: val } ) }
						help={ __( 'Show zoom icon when hovering the slide background', 'eedee-gutenslider' ) }
					/>
					<ToggleControl
						label={ __( 'Show Counter in Lightgallery', 'eedee-gutenslider' ) }
						checked={ hasLgCounter }
						onChange={ ( val ) => setAttributes( { hasLgCounter: val } ) }
					/>
					<SelectControl
						label={ __( 'Lightgallery Transition', 'eedee-gutenslider' ) }
						value={ lgTransition }
						options={ LIGHTGALLERY_TRANSITIONS }
						onChange={ ( val ) => {
							setAttributes( { lgTransition: val } );
						} }
					/>
					<SelectControl
						label={ __( 'Lightgallery Media Title', 'eedee-gutenslider' ) }
						value={ lgTitle }
						options={ LIGHTGALLERY_TITLE }
						onChange={ ( val ) => {
							setAttributes( { lgTitle: val } );
						} }
					/>
					<SelectControl
						label={ __( 'Lightgallery Media Caption', 'eedee-gutenslider' ) }
						value={ lgCaption }
						options={ LIGHTGALLERY_DESCRIPTION }
						onChange={ ( val ) => {
							setAttributes( { lgCaption: val } );
						} }
					/>
				</> }
			</PanelBody>
			{ false && <PanelBody
				title={ __( 'Art Settings', 'eedee-gutenslider' ) }
				initialOpen={ false }
			>
				<SelectControl
					label={ __( 'Mix Blend Mode', 'eedee-gutenslider' ) }
					value={ mixBlendMode }
					options={ [
						{ label: 'None', value: '' },
						{ label: 'Color Burn', value: 'color-burn' },
						{ label: 'Color Dodge', value: 'color-dodge' },
						{ label: 'Difference', value: 'difference' },
						{ label: 'Exclusion', value: 'exclusion' },
						{ label: 'Saturation', value: 'saturation' },
					] }
					onChange={ ( val ) => setAttributes( { mixBlendMode: val } ) }
				/>
				<RangeControl
					label={ __( 'Content Opacity', 'eedee-gutenslider' ) }
					value={ contentOpacity }
					onChange={ ( val ) => setAttributes( { contentOpacity: val } ) }
					min={ 0 }
					max={ 1 }
					step={ 0.1 }
				/>
			</PanelBody> }
		</InspectorControls>
	);
};
